import { createI18n, type DefaultLocaleMessageSchema } from 'vue-i18n';
import enus from './en-us';
import esus from './es-us';
import enca from './en-ca';
import frca from './fr-ca';
import { enCA, enUS, esUS, frCA } from '@primerica/onex-ui-lib';

const usNumberFormat = {
  currency: {
    style: 'currency' as const,
    currency: 'USD',
  },
  currencyNoCents: {
    style: 'currency' as const,
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
};

const caNumberFormat = {
  currency: {
    style: 'currency' as const,
    currency: 'CAD',
  },
  currencyNoCents: {
    style: 'currency' as const,
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
};

const numberFormats = {
  'en-US': usNumberFormat,
  'es-US': usNumberFormat,
  'en-CA': caNumberFormat,
  'fr-CA': caNumberFormat,
};

const options = {
  messages: {
    'en-US': { ...enUS, ...enus },
    'es-US': { ...esUS, ...esus },
    'en-CA': { ...enCA, ...enca },
    'fr-CA': { ...frCA, ...frca },
  },
  locale: 'en-US',
  fallbackLocale: 'en-US',
  numberFormats,
  legacy: true,
};
export const i18n = createI18n<[DefaultLocaleMessageSchema], 'en-US' | 'es-US' | 'fr-CA', true>(
  options
);
